import datadog from "../services/logger";
import axios, { AxiosError } from "axios";
import { checkAxiosError } from "./checkAxiosError";
import { InvitationDisplayResponse } from "./services.types";
import { FetchingStatus, MatcherInvitationContext } from "../shared/types";

const url = import.meta.env.VITE_PORTAL_URL;

export const postAcceptMatcherInvitation = async (candidateToken) => {
  datadog.logger.info(
    `postAcceptMatcherInvitation: Accepting invitation for candidate token ${candidateToken}`,
  );

  try {
    const result = await axios.post<InvitationDisplayResponse>(
      `${url}/api/invitation/accept?token=${candidateToken}`,
      {},
    );

    return { success: true, data: result.data };
  } catch (err) {
    return checkAxiosError(
      err as AxiosError<any>,
      `postAcceptMatcherInvitation: Error accepting invitation for candidate token ${candidateToken}`,
    );
  }
};

export const postDeclineMatcherInvitation = async (candidateToken) => {
  datadog.logger.info(
    `postDeclineMatcherInvitation: Declining invitation for candidate token ${candidateToken}`,
  );

  try {
    const result = await axios.post(
      `${url}/api/invitation/decline?token=${candidateToken}`,
      {},
    );

    return { success: true, data: result.data };
  } catch (err) {
    return checkAxiosError(
      err as AxiosError<any>,
      `postDeclineMatcherInvitation: Error declining invitation for candidate token ${candidateToken}`,
    );
  }
};

export const updateMatcherAcceptInvitation = async ({
  token,
  setMatcherInvitationContext,
  matcherInvitationAcceptFS,
  setMatcherInvitationAcceptFS,
}: {
  token: string | null;
  setMatcherInvitationContext: React.Dispatch<
    React.SetStateAction<MatcherInvitationContext | null>
  >;
  matcherInvitationAcceptFS: FetchingStatus;
  setMatcherInvitationAcceptFS: React.Dispatch<
    React.SetStateAction<FetchingStatus>
  >;
}) => {
  if (matcherInvitationAcceptFS === "ongoing") return;

  setMatcherInvitationAcceptFS("ongoing");

  if (!token) {
    setMatcherInvitationContext(null);
    setMatcherInvitationAcceptFS("errored");
    return;
  }

  const result = await postAcceptMatcherInvitation(token);

  if (!result.success) {
    setMatcherInvitationContext(null);
    setMatcherInvitationAcceptFS("errored");
    return;
  }

  const data: InvitationDisplayResponse = result.data;

  setMatcherInvitationContext({
    invitationSource: data.invitation_source,
    hiringPhase: data.hiring_phase,
    hiringStrategy: data.hiring_strategy,
  });

  setMatcherInvitationAcceptFS("done");
};

export const updateMatcherDeclineInvitation = async ({
  token,
  matcherInvitationDeclineFS,
  setMatcherInvitationDeclineFS,
}: {
  token: string | null;
  matcherInvitationDeclineFS: FetchingStatus;
  setMatcherInvitationDeclineFS: React.Dispatch<
    React.SetStateAction<FetchingStatus>
  >;
}) => {
  if (matcherInvitationDeclineFS === "ongoing") return;
  
  setMatcherInvitationDeclineFS("ongoing");

  if (!token) {
    setMatcherInvitationDeclineFS("errored");
    return;
  }

  const result = await postDeclineMatcherInvitation(token);

  if (!result.success) {
    setMatcherInvitationDeclineFS("errored");
    return;
  }

  setMatcherInvitationDeclineFS("done");
};
